const BASE_API_URL =
  process.env.NODE_ENV === "development"
    ? `${window.location.protocol}//localhost:${process.env.REACT_APP_PORT}`
    : process.env.REACT_APP_BASE_URL; // Production URLs should always be HTTPS
const BASE_URL =
  process.env.NODE_ENV === "development"
    ? `${window.location.protocol}//localhost:${process.env.REACT_APP_PORT}`
    : process.env.REACT_APP_BASE_URL; // Production URLs should always be HTTPS

const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;

export const config = {
  url: {
    BASE_URL: BASE_URL,
    BASE_API_URL: BASE_API_URL,
    TINYMCE_API_KEY: TINYMCE_API_KEY,
    WWW: `${BASE_URL}/www`,
    LOGOUT_SUCCESS: "https://shibboleth.main.ad.rit.edu/logout.html",

    API_LOGIN: `${BASE_API_URL}/saml/login`,
    API_LOGOUT: `${BASE_API_URL}/saml/logout`,

    PROPOSAL_FORM: `${BASE_URL}/proposal-form`,

    // No auth needed
    API_GET_ACTIVE_ARCHIVES: `${BASE_API_URL}/db/getActiveArchiveProjects`,
    API_GET_ARCHIVES: `${BASE_API_URL}/db/getArchiveProjects`,
    API_GET_ARCHIVE_POSTER: `${BASE_API_URL}/db/getArchivePoster`,
    API_GET_ARCHIVE_VIDEO: `${BASE_API_URL}/db/getArchiveVideo`,
    API_GET_ARCHIVE_IMAGE: `${BASE_API_URL}/db/getArchiveImage`,
    API_POST_SUBMIT_PROJECT: `${BASE_API_URL}/db/submitProposal`,
    API_GET_SEARCH_FOR_ARCHIVES: `${BASE_API_URL}/db/searchForArchive`,
    API_GET_ARCHIVE_FROM_SLUG: `${BASE_API_URL}/db/getArchiveFromSlug`,
    API_GET_ARCHIVE_FROM_PROJECT: `${BASE_API_URL}/db/getArchiveFromProject`,
    API_GET_FEATURED_ARCHIVES: `${BASE_API_URL}/db/getFeaturedArchiveProjects`,
    API_POST_EDIT_ARCHIVE_STUDENT: `${BASE_API_URL}/db/editArchiveStudent`,
    API_POST_CREATE_ARCHIVE_STUDENT: `${BASE_API_URL}/db/createArchiveStudent`,
    API_POST_UPLOAD_FILES_STUDENT: `${BASE_API_URL}/db/uploadFilesStudent`,

    // GET - Auth needed
    API_WHO_AM_I: `${BASE_API_URL}/saml/whoami`,
    API_GET_PROJECTS: `${BASE_API_URL}/db/getProjects`,
    API_GET_MY_PROJECTS: `${BASE_API_URL}/db/getMyProjects`,
    // Grabs project or projects (i.e. coach) info for specific user.
    API_GET_SEMESTER_PROJECTS: `${BASE_API_URL}/db/getSemesterProjects`,
    API_GET_CANDIDATE_PROJECTS: `${BASE_API_URL}/db/getCandidateProjects`,
    API_GET_PROJECT_MEMBERS: `${BASE_API_URL}/db/getProjectMembers`,
    // Get below is currently unused.
    API_GET_ARCHIVE_MEMBERS: `${BASE_API_URL}/db/getArchiveMembers`,
    // Grabs all the semester data from semester_groups and orders them by start and end date.
    API_GET_SEMESTERS: `${BASE_API_URL}/db/getSemesters`,
    API_GET_ACTIONS: `${BASE_API_URL}/db/getActions`,
    API_GET_SEMESTER_ANNOUNCEMENTS: `${BASE_API_URL}/db/getSemesterAnnouncements`,
    API_GET_TIMELINE_ACTIONS: `${BASE_API_URL}/db/getTimelineActions`,
    API_GET_PROPOSAL_PDF: `${BASE_API_URL}/db/getProposalPdf`,
    API_GET_PROPOSAL_ATTACHMENT: `${BASE_API_URL}/db/getProposalAttachment`,
    API_GET_STUDENT_INFO: `${BASE_API_URL}/db/selectAllStudentInfo`,
    API_GET_NON_STUDENT_INFO: `${BASE_API_URL}/db/selectAllNonStudentInfo`,
    API_GET_ACTIVE_PROJECTS: `${BASE_API_URL}/db/getActiveProjects`,
    API_GET_ACTIVE_TIMELINES: `${BASE_API_URL}/db/getActiveTimelines`,
    API_GET_ACTION_LOGS: `${BASE_API_URL}/db/getActionLogs`,
    API_GET_ALL_ACTION_LOGS: `${BASE_API_URL}/db/getAllActionLogs`,
    API_GET_ALL_ERROR_LOGS: `${BASE_API_URL}/db/getAllErrorLogs`,
    API_GET_TIME_LOGS: `${BASE_API_URL}/db/getTimeLogs`,
    API_GET_ALL_TIME_LOGS: `${BASE_API_URL}/db/getAllTimeLogs`,
    API_GET_TIME_AVG: `${BASE_API_URL}/db/avgTime`,
    API_GET_SUBMISSION: `${BASE_API_URL}/db/getSubmission`,
    API_GET_PROJECT_STUDENT_NAMES: `${BASE_API_URL}/db/getProjectStudentNames`,
    API_GET_SUBMISSION_FILE: `${BASE_API_URL}/db/getSubmissionFile`,
    API_GET_ALL_COACH_INFO: `${BASE_API_URL}/db/selectAllCoachInfo`,
    API_GET_PROJECT_COACHES: `${BASE_API_URL}/db/getProjectCoaches`,
    API_GET_PROJECT_STUDENTS: `${BASE_API_URL}/db/getProjectStudents`,
    API_GET_ACTIVE_COACHES: `${BASE_API_URL}/db/getActiveCoaches`,
    API_GET_SEMESTER_STUDENTS: `${BASE_API_URL}/db/getSemesterStudents`,
    API_GET_ACTIVE_USERS: `${BASE_API_URL}/db/getActiveUsers`,
    API_GET_ALL_SPONSORS: `${BASE_API_URL}/db/getAllSponsors`,
    API_GET_PROJECT_SPONSOR: `${BASE_API_URL}/db/getProjectSponsor`,
    API_GET_SPONSOR_NOTES: `${BASE_API_URL}/db/getSponsorNotes`,
    API_GET_SEARCH_FOR_SPONSOR: `${BASE_API_URL}/db/searchForSponsor`,
    API_GET_SPONSOR_PROJECTS: `${BASE_API_URL}/db/getSponsorProjects`,
    API_GET_ARCHIVE_PROJECT: `${BASE_API_URL}/db/getArchiveProject`,
    API_GET_LATE_SUBMISSION: `${BASE_API_URL}/db/getLateSubmission`,
    API_GET_FILES: `${BASE_API_URL}/db/getFiles`,
    API_GET_HTML: `${BASE_API_URL}/db/getHtml`,
    API_GET_SPONSOR_DATA: `${BASE_API_URL}/db/getSponsorData`,
    API_GET_ARCHIVE: `${BASE_API_URL}/db/getArchive`,
    API_GET_ADDITIONAL_INFO: `${BASE_API_URL}/db/getAdditionalInfo`,
    API_GET_PEER_EVALS: `${BASE_API_URL}/db/getPeerEvals`,
    API_GET_DARK_MODE: `${BASE_API_URL}/db/getDarkMode`,
    API_GET_GANTT_VIEW: `${BASE_API_URL}/db/getGanttView`,
    API_GET_CALENDAR_VIEW: `${BASE_API_URL}/db/getCalendarView`,
    API_GET_MILESTONE_VIEW: `${BASE_API_URL}/db/getMilestoneView`,
    //AI API calls
    API_GENERATE_SUMMARY: `${BASE_API_URL}/ai/GenerateSummary`,
    API_GENERATE_HISTORIC_SUMMARY: `${BASE_API_URL}/ai/GenerateHistoricSummary`,
    API_GENERATE_RESPONSE: `${BASE_API_URL}/ai/GenerateResponse`,
    API_CHECK_GEMINI_KEY_EXISTS: `${BASE_API_URL}/ai/CheckGeminiKeyExists`,
    //Matches semester from project table to semester_id from semester_groups, returns start and end date
    API_GET_START_AND_END_DATE: `${BASE_API_URL}/db/getProjectDates`,
    API_GET_COACH_FEEDBACK: `${BASE_API_URL}/db/getCoachFeedback`,
    // POST - Auth needed
    API_POST_EDIT_PROJECT: `${BASE_API_URL}/db/editProject`,
    API_POST_SUBMIT_ACTION: `${BASE_API_URL}/db/submitAction`,
    API_POST_EDIT_ACTION: `${BASE_API_URL}/db/editAction`,
    API_POST_CREATE_ACTION: `${BASE_API_URL}/db/createAction`,
    API_POST_CREATE_TIME_LOG: `${BASE_API_URL}/db/createTimeLog`,
    API_POST_EDIT_SEMESTER: `${BASE_API_URL}/db/editSemester`,
    API_POST_CREATE_SEMESTER: `${BASE_API_URL}/db/createSemester`,
    API_POST_EDIT_USER: `${BASE_API_URL}/db/editUser`,
    API_POST_CREATE_USER: `${BASE_API_URL}/db/createUser`,
    API_POST_BATCH_CREATE_USER: `${BASE_API_URL}/db/batchCreateUser`,
    API_POST_CREATE_DIRECTORY: `${BASE_API_URL}/db/createDirectory`,
    API_POST_RENAME_FILES_DIRECTORY: `${BASE_API_URL}/db/renameDirectoryOrFile`,
    API_POST_UPLOAD_FILES: `${BASE_API_URL}/db/uploadFiles`,
    API_POST_CREATE_SPONSOR: `${BASE_API_URL}/db/createSponsor`,
    API_POST_EDIT_SPONSOR: `${BASE_API_URL}/db/editSponsor`,
    API_POST_CREATE_SPONSOR_NOTE: `${BASE_API_URL}/db/createSponsorNote`,
    API_POST_EDIT_PAGE: `${BASE_API_URL}/db/editPage`,
    API_POST_EDIT_ARCHIVE: `${BASE_API_URL}/db/editArchive`,
    API_POST_CREATE_ARCHIVE: `${BASE_API_URL}/db/createArchive`,
    API_DELETE_TIME_LOG: `${BASE_API_URL}/db/removeTime`,
    API_DELETE_ERROR_LOG: `${BASE_API_URL}/db/removeErrorLog`,
    API_POST_EDIT_ADDITIONAL_INFO: `${BASE_API_URL}/db/editAdditionalInfo`,
    API_POST_SET_DARK_MODE: `${BASE_API_URL}/db/setDarkMode`,
    API_POST_SET_GANTT_VIEW: `${BASE_API_URL}/db/setGanttView`,
    API_POST_SET_CALENDAR_VIEW: `${BASE_API_URL}/db/setCalendarView`,
    API_POST_SET_MILESTONE_VIEW: `${BASE_API_URL}/db/setMilestoneView`,

    //DELETE - Auth needed
    API_DELETE_FILE: `${BASE_API_URL}/db/removeFile`,
    API_DELETE_DIRECTORY: `${BASE_API_URL}/db/removeDirectory`,

    // PATCH - Auth needed
    API_PATCH_EDIT_PROPOSAL_STATUS: `${BASE_API_URL}/db/updateProposalStatus`,

    // *** DEVELOPMENT ONLY ***
    DEV_ONLY_API_GET_ALL_USERS: `${BASE_API_URL}/db/DevOnlyGetAllUsersForLogin`,
    DEV_ONLY_API_POST_EDIT_LAST_LOGIN: `${BASE_API_URL}/saml/DevOnlyLastLogin`,
    DEV_ONLY_REDEPLOY_DATABASE: `${BASE_API_URL}/db/DevOnlyRedeployDatabase`,
  },
};

export const USERTYPES = {
  COACH: "coach",
  STUDENT: "student",
  ADMIN: "admin",
};

export const ACTION_TARGETS = {
  individual: "individual",
  team: "team",
  coach: "coach",
  admin: "admin",
  student_announcement: "student_announcement",
  coach_announcement: "coach_announcement",
  peer_evaluation: "peer_evaluation",
};

export const DROPDOWN_ITEMS = {
  actionTarget: [
    {
      key: "individual",
      text: "Individual Action",
      value: "individual",
    },
    {
      key: "team",
      text: "Team Action",
      value: "team",
    },
    {
      key: "coach",
      text: "Coach Action",
      value: "coach",
    },
    {
      key: "admin",
      text: "Admin Action",
      value: "admin",
    },
    {
      key: "student_announcement",
      text: "Student Announcement",
      value: "student_announcement",
    },
    {
      key: "coach_announcement",
      text: "Coach Announcement",
      value: "coach_announcement",
    },
    // TODO: This is where we would add action targets
    {
      key: "peer_evaluation",
      text: "Peer Evaluation",
      value: "peer_evaluation",
    },
    {
      key: "break_period",
      text: "Break Period",
      value: "break_period",
    },
  ],

  userTypes: [
    {
      key: "student",
      value: "student",
      text: "Student",
    },
    {
      key: "coach",
      value: "coach",
      text: "Coach",
    },
    {
      key: "admin",
      value: "admin",
      text: "Admin",
    },
  ],
};

export const PROJECT_STATUSES = {
  SUBMITTED: "submitted",
  NEEDS_REVISION: "needs revision",
  REJECTED: "rejected",
  FUTURE_PROJECT: "future project",
  CANDIDATE: "candidate",
  IN_PROGRESS: "in progress",
  COMPLETE: "completed",
  ARCHIVED: "archive",
};

export const ACTION_STATES = {
  YELLOW: "yellow",
  RED: "red",
  GREEN: "green",
  GREY: "grey",
  PURPLE: "purple", //used for break period
};

export const SERVER_TIMEZONE = "America/New_York";

export const DEFAULT_UPLOAD_LIMIT = 15 * 1024 * 1024;

//Defualt AI prompts
export const PROMPT_GENERATE_HISTORIC_SUMMARY = `You are a writing assistant that provides a historical performance summary for a student based on their peer reviews over time.
Summarize and chronicle the evolution of the student's performance, highlighting key improvements and recurring challenges.

Input Specification:
    The input will be a JSON array of review objects representing the student's past evaluations.
    Each review will contain a timestamp, reviewer identity, and structured feedback.

    The input format will be:
    [
        {
            "submission_datetime": "Timestamp of review submission",
            "form_data": "{\\"Students\\":{\\"Student Name\\":{\\"Feedback\\":{\\"Category\\":\\"Feedback entered in form\\"},\\"Ratings\\":{\\"Category\\":Numeric Rating}}}}"
        },
        ...
    ]

    - form_data contains feedback categories and ratings for the student.
    - Each review is submitted at a different time, allowing trends to be analyzed.

Output Specification:
    1. Focus on trends and changes over time.
    2. Identify key improvements and recurring challenges in performance.
    3. The summary should be a comprehensive paragraph written in a reflecting historical performance.  
`;

export const PROMPT_GENERATE_FEEDBACK_SUMMARY = `You are an writing assistant that is providing a student their project performance based upon their peer's feedback
Summarize and anonymize the following peer review feedback from a student project. 
In JSON format, You'll be given categorized feedback for a student from their team members.
Create a  anonymized paragraph that captures the key points and overall sentiment of the feedback. 

Input Specification:
    Will be in Json With this format:
    {
        Student: "Student context is for",
        Ratings: {
            From: "Student Feedback is From",
            Feedback: {
                "Category": "Feedback entered in form"
            }
        }
    }  

Output Specification: 
    1. Do not include any names or identifying information. (Do not say you can not reveal names either)
    2. Focus on providing constructive insights that the student can use to improve their performance. 
    3. The summary should be concise, typically 3-5 sentences, highlighting strengths and areas for improvement. 
    4. Output should be in paragraph form.   
    5. Speak in the POV as the team coach talking to the student
    6. Do not format your response as a JSON
`;
